<template>
    <div>
        <div v-if="type == 'images'" class="article-card" style="height: 300px;">
            <div class="article-card__cover" style="height: 300px;">
                <img :src="item.file_url" style="height: 300px;" @click="showPreview()" />
            </div>
        </div>
        <div v-else class="article-card" @click="handleClick(item)">
            <div class="article-card__cover">
                <img v-if="item.cover_image_url" :src="item.cover_image_url" />
                <img v-else-if="item.image_url" :src="item.image_url" />
                <img v-else src="https://edu-img.therol.cn/autohk/11.png" />
            </div>

            <div class="article-card__title">
                <div class="title">{{ item.title }}</div>
            </div>
            <div class="article-card__summary">{{ item.summary }}</div>

            <div class="article-card__end">
                <div class="time" v-if="item.publish_time">{{ dayjs(item.publish_time).format('YYYY/MM/DD') }}</div>
                <div class="article-card__more">
                    {{ lang.more }}
                    <img src="@assets/news/icon_next.png" srcset="@assets/news/icon_next@2x.png 2x" alt="" />
                </div>
            </div>

        </div>

        <ImagePreview v-if="visible" :imageList="images" :initialIndex="currentIndex" @close="visible = false" />
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import dayjs from 'dayjs';
import { useRouter } from 'vue-router'
import ImagePreview from '@/components/imagePreview/index.vue';
const router = useRouter()

defineProps({
    item: { type: Object },
    type: { type: String },
    images: { type: Array },
    currentIndex: { type: Number }
})

// 语言包
const language = localStorage.getItem("language") || "zh"
const lang = ref({})
import(`@/language/${language}.js`).then(data => {
    lang.value = data.default.news
})


const handleClick = (item) => {
    // window.open(`/article?id=${item.id}`, '_blank')
    router.push({ path: `/article/${item.id}` })
}

const visible = ref(false);

const showPreview = () => {
  visible.value = true;
};


</script>

<style lang="scss" scoped>
.article-card {
    width: 423px;
    height: 341px;
    border-radius: 30px;
    box-shadow: 0px 2px 18px 0px rgba(67, 67, 67, 0.18);
    overflow: hidden;
    background-color: #FFFFFF;
    margin-bottom: 24px;
    cursor: pointer;

    &__cover {
        width: 100%;
        height: 200px;
        overflow: hidden;

        img {
            width: 100%;
            height: 200px;
            object-fit: cover;
            transition: all 0.3s ease-in-out;
        }

        img:hover {
            transform: scale(1.2);
        }
    }

    &__title {
        color: #333333;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        padding: 24px 22px 0 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;


        .title {
            font-family: PingFangSC-medium;
            max-width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

    }

    &__summary {
        color: #666666;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        margin: 8px 22px 8px 22px;
        height: 40px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;   
    }

    &__end {
        display: flex;
        align-items: center;
        padding: 0px 22px 24px 22px;
        justify-content: space-between;

        .time {
            font-family: Roboto-regular;
            color: #999999;
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
        }
    }

    &__more {
        font-family: PingFangSC-medium;
        color: #0E4EAD;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;

        img {
            margin-left: 6px;
        }
    }

    &__more:hover {
        opacity: 0.75;
    }
}

/* 响应式布局 */
@media (max-width: 768px) {
    .article-card {
        width: 100%;
        height: auto;
        margin-bottom: 12px;
        cursor: pointer;
        border-radius: 10px;

        &__title {
            font-size: 16px;
            line-height: 20px;
            padding: 12px 11px 0 11px;

            .title {
                max-width: 350px;
                
            }
        }

        &__summary {
            font-size: 12px;
            line-height: 20px;
            padding: 4px 11px 4px 11px;
        }

        &__end {
            display: flex;
            align-items: center;
            padding: 0px 11px 12px 11px;
            justify-content: space-between;

            .time {
                font-size: 10px;
                line-height: 14px;
            }
        }

        &__more {
            font-size: 12px;
            line-height: 20px;

            img {
                margin-left: 4px;
                width: 10px;
                height: 10px;
            }
        }
    }
}
</style>